// extracted by mini-css-extract-plugin
export default {"authLayoutLogo":"logo_authLayoutLogo__uwzB1","authLogoPartOne":"logo_authLogoPartOne__ADLZs","authLogoPartTwo":"logo_authLogoPartTwo__FnEOY","mTradeLogo":"logo_mTradeLogo__PMc2y"};